import { useSplitTreatment } from './useSplitTreatment';
import {
  SPLIT_IO_FEATURE_FLAG_EXPLORE_SIMILAR_PRODUCTS,
  SPLIT_IO_FEATURE_FLAG_EXPLORE_SIMILAR_PRODUCTS_COOKIE
} from 'constants/split';
import { SPLIT_TRAFFIC_TYPES } from 'au-js-sdk/lib/services/split.io/constants';
import { SKU_COLOR_SERIES, SKU_HARDCOVER, SKU_LAYFLAT, SKU_PHOTO_WRAPPED_HARDCOVER, SKU_PHOTO_WRAPPED_LAYFLAT, SKU_SIG_LAY, SKU_SOFTCOVER } from 'components/constants/products';

const PRODUCTS_IN_TEST = [
  SKU_HARDCOVER,
  SKU_LAYFLAT
];

export const useSimilarProductsBySize = (sku: string): boolean => {
  const { treatmentStatus: splitEnabled } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_EXPLORE_SIMILAR_PRODUCTS,
    SPLIT_IO_FEATURE_FLAG_EXPLORE_SIMILAR_PRODUCTS_COOKIE,
    SPLIT_TRAFFIC_TYPES.ANONYMOUS
  );

  return splitEnabled && PRODUCTS_IN_TEST.includes(sku);
};

/* Temporary, this should be configurable in magento */
export const PRODUCT_GROUPS_BY_SIZE = {
  '8.5x8.5': [
    SKU_HARDCOVER,
    SKU_LAYFLAT,
    SKU_PHOTO_WRAPPED_HARDCOVER,
    SKU_PHOTO_WRAPPED_LAYFLAT,
    SKU_SIG_LAY,
    SKU_SOFTCOVER,
    SKU_COLOR_SERIES
  ],
  '10x10': [
    SKU_HARDCOVER,
    SKU_LAYFLAT,
    SKU_PHOTO_WRAPPED_HARDCOVER,
    SKU_PHOTO_WRAPPED_LAYFLAT,
    SKU_SIG_LAY,
    SKU_SOFTCOVER
  ],
  '8.25x11': [
    SKU_HARDCOVER,
    SKU_LAYFLAT,
    SKU_PHOTO_WRAPPED_HARDCOVER,
    SKU_PHOTO_WRAPPED_LAYFLAT,
    SKU_SIG_LAY,
    SKU_SOFTCOVER
  ],
  '11x8.25': [
    SKU_HARDCOVER,
    SKU_LAYFLAT,
    SKU_PHOTO_WRAPPED_HARDCOVER,
    SKU_PHOTO_WRAPPED_LAYFLAT,
    SKU_SIG_LAY,
    SKU_SOFTCOVER
  ]
};